import { render, staticRenderFns } from "./GroupTagLayout.vue?vue&type=template&id=630b9bb0"
import script from "./GroupTagLayout.vue?vue&type=script&lang=js"
export * from "./GroupTagLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports